// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Hpm5T","logo":"Header_logo__kE5iJ","menu":"Header_menu__H47q3","nav":"Header_nav__-3ty0","display":"Header_display__LiJLA"};